interface BottomFixState {
  isVisible: boolean
}

export const useBottomFix = () => {
  const state = useState<BottomFixState>('bottomFix', () => ({
    isVisible: false,
  }))

  const show = () => {
    state.value.isVisible = true
  }

  const hide = () => {
    state.value.isVisible = false
  }

  return {
    state,
    show,
    hide,
  }
}
